'use client'

import clsx from 'clsx'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import S from './VerifiedMark.module.scss'

const VERIFIED_MARK_SRC = '/assets/profile-check-mark.png'

interface VerifiedMarkProps {
  /** Rendered size in px (CSS may still override it per place). */
  size?: number
  className?: string
}

/**
 * BAT-597: the Verified check mark of a club or an athlete — a manual admin
 * flag. Render it only when the API's `is_verified` is true (the gateway
 * already hides it for a profile that is not live).
 */
export function VerifiedMark({ size = 16, className }: VerifiedMarkProps) {
  const t = useTranslations('common')
  const label = t('verified')
  return (
    <Image
      src={VERIFIED_MARK_SRC}
      alt={label}
      title={label}
      width={size}
      height={size}
      className={clsx(S.mark, className)}
    />
  )
}

export default VerifiedMark
